import React, { useState, useEffect } from 'react';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';
import RiseLoading from '@/routes/components/Loading';
import './style';

const TokenWrapper = WrappedComponent => ({ ...props }) => {
  const [token, setToken] = useState('');
  let timer = null;
  useEffect(() => {
    timer = setInterval(() => {
      const userInfo = getIdentity(IDENTITY_KEY_NAME.TOKEN, undefined);
      if (userInfo) {
        clearInterval(timer);
        timer = null;
      }
      setToken(userInfo ? userInfo.substring(0, 10) : 'no-token');
    }, 100);
    return () => clearInterval(timer);
  });

  return (
    <div>
      <div className={`token ${token === 'no-token' ? 'error' : ''}`} />
      {token ? <WrappedComponent {...props} /> : <RiseLoading />}
    </div>
  );
};

export default TokenWrapper;
